import { defineComponent as _defineComponent } from 'vue'
import CourseDetails from '@/ui/components/trainings/courseBuilder/CourseDetails.vue';
  import SectionsTree from '@/ui/components/trainings/courseBuilder/SectionsTree.vue';
  import ComponentEditor from '@/ui/components/trainings/courseBuilder/ComponentEditor.vue';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';
  import { router } from '@/ui/routes';
  import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Box } from '@/ui/components/Box';
  import { onBeforeUnmount, onMounted } from 'vue';
  import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';
  import { storeToRefs } from 'pinia';
  import { Loading } from '@/ui/components/Loading';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseBuilderPage',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const courseBuilder = useCourseBuilderStore();
  const { course, isLoading } = storeToRefs(courseBuilder);

  const handleClose = () => {
    router.push({ name: 'courses' });
  };

  const handleSaveChanges = async () => {
    try {
      await courseBuilder.save();
      toasted.success(t('trainings.course-saved'));
    } catch (e) {
      console.error('Failed to save course:', e);
      toasted.error(`Failed to save course: ${(e as Error).message}`);

      return false;
    }

    return true;
  };

  const handleSaveAndExit = () => {
    handleSaveChanges().then(success => {
      if (success) {
        router.push({ name: 'courses' });
      }
    });
  };

  onMounted(() => {
    courseBuilder.loadCourse(props.id);
  });

  onBeforeUnmount(() => {
    courseBuilder.$reset();
  });

return { __sfc: true,props, courseBuilder, course, isLoading, handleClose, handleSaveChanges, handleSaveAndExit, CourseDetails, SectionsTree, ComponentEditor, Button, Icon, Box, Loading }
}

})